import type { UnitResource } from "../../unit";
import type { AttributeValueResource } from "../../attribute-value";

export enum AttributeTypeEnum {
  TextField = "text_field",
  Float = "float",
  Integer = "integer",
  DateTime = "date_time",
  Date = "date",
  SelectionList = "selection_list",
}

export const AttrTypes = {
  TEXT_FIELD: "text_field",
  FLOAT: "float",
  INTEGER: "integer",
  DATE_TIME: "date_time",
  DATE: "date",
  SELECTION_LIST: "selection_list",
};

export interface AttributeResource {
  id: string;
  gid: string;
  title: string;
  is_multiple_allowed: boolean;
  attribute_type: AttributeTypeEnum;
  sort_order: string;
  attribute_unit_id: string | undefined;
  is_sort_options_alphabetically: boolean;
  unit?: UnitResource;
  attributeValues?: AttributeValueResource[];
}

export type CreateAttributeRequestBody = {
  title: string;
  is_multiple_allowed?: boolean;
  attribute_type?: AttributeTypeEnum;
  sort_order?: number | null;
  attribute_unit_id?: string | null;
  is_sort_options_alphabetically?: boolean;
};

export type UpdateAttributeRequestBody = {
  title?: string;
  multiple_allowed?: boolean;
  attribute_type?: AttributeTypeEnum;
  sort_order?: string | null;
  attribute_unit_id?: string | null;
  is_sort_options_alphabetically?: boolean;
  confirmation?: boolean;
};
